import { render, staticRenderFns } from "./MessageFooter.vue?vue&type=template&id=5e4efedc&scoped=true&"
import script from "./MessageFooter.vue?vue&type=script&lang=js&"
export * from "./MessageFooter.vue?vue&type=script&lang=js&"
import style0 from "./MessageFooter.vue?vue&type=style&index=0&id=5e4efedc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4efedc",
  null
  
)

export default component.exports